import React, { createContext, useEffect, useState } from 'react';
import { Terminal } from '../clients/quipli-service/payment/payment';
import { PaymentMethodConfig } from '../clients/quipli-service/payment-config/payment-config';
import { usePaymentConfigApiV1 } from '../clients/quipli-service/payment-config/payment-config-api-v1';

export type PaymentContext = {
  terminals: Terminal[];
  paymentMethods: PaymentMethodConfig[];
  currency: string;
};

export const PaymentContext = createContext<PaymentContext | undefined>(undefined);

export const PaymentContextProvider = ({ children }: React.PropsWithChildren) => {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [paymentContext, setPaymentContext] = useState<PaymentContext>();
  const { getContext } = usePaymentConfigApiV1();

  const getPaymentContextFromAPI = () => {
    getContext().then((context) => {
      setPaymentContext(context);
      setIsLoading(false);
    });
  };

  useEffect(() => {
    getPaymentContextFromAPI();
  }, []);

  return !isLoading ? <PaymentContext.Provider value={paymentContext}>{children}</PaymentContext.Provider> : null;
};
